export const FIND_PROCESS_STATEMENT_FAILURE = 'FIND_PROCESS_STATEMENT_FAILURE';

export const findProcessStatementFailure = error => ({
    type: FIND_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
